<template>
  <div class="onlineJdPopModel">
    <div class="wrapper">
      <el-form ref="ruleForm" :rules="rules" :model="formData" label-width="120px">
        <el-row :gutter="22">
          <el-col :span="24">
            <el-form-item label="选择仓库：" prop="depotId">
              <el-select
                style="width: 79%"
                v-model="formData.depotId"
                placeholder="请选择仓库"
                @change="onChangeDepot"
              >
                <el-option
                  v-for="item in DepotInfo"
                  :key="item.id"
                  :label="item.depotName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="24">
            <el-form-item label="送检仪器：" prop="selectValue">
              <el-transfer
                style="width: 100%"
                :titles="['待检定仪器', '本次送检仪器']"
                v-model="formData.selectValue"
                :data="VertifyInstrument"
              ></el-transfer>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="24">
            <el-form-item label="接收公司：" prop="companyId">
              <el-select
                style="width: 79%"
                v-model="formData.companyId"
                placeholder="请选择"
                @change="onChange"
              >
                <el-option
                  v-for="item in companyOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="footer">
      <el-button @click="toCancel()">取消</el-button>
      <el-button type="primary" @click="toSubmit()">提交</el-button>
    </div>
  </div>
</template>

<script>
import { getDepotInfo, GetVertifyInstrument } from "@/api/depotApi";
import { PreView } from "@/api/VertifyOrder";
export default {
  name: "OnlineTestModal",
  props: {
    message: {
      type: Object
    },
  },
  data() {
    return {
      // rowInstrumentListData: [],
      formData: {
        depotId: null,
        selectValue: [],
        companyId: []
      },
      companyOptions: [
        { id: 1, name: "广州广电计量检测股份有限公司" },
      ],
      rules: {
        selectValue: [{ required: true, message: '请选择送检仪器', trigger: 'change' }],
        companyId: [{ required: true, message: '请选择接收公司', trigger: 'blur' }]
      },
      outTradeNo: "",
      selectCompanyName: "",
      DepotInfo: [],
      VertifyInstrument: [],
      userInfo: '',
    }
  },
  created() {
    // this.initData();
    this.userInfo = this.$store.state.user.userInfo;
  },
  mounted() {
    this.GetDepotInfo();
  },
  methods:{
    // initData() {
    //   let self = this;
    //   self.message.instrumentList.forEach(item => {
    //     self.rowInstrumentListData.push({
    //       key: item.id,
    //       label: item.instrumentName,
    //     })
    //   })
    // },
    onChange(val) {
      let self = this;
      self.selectCompanyName = self.companyOptions.find(item => {
        return item.id == val;
      }).name;
    },
    toCancel() {
      this.$emit("handle-cancel", {})
    },
    toSubmit() {
      let self = this;
      self.$refs.ruleForm.validate(valid => {
        if (valid) {
          let detail = this.formData.selectValue.map((item, index) => {
            return { instrumentId: item }
          })
          PreView({
            deptId: Number(this.userInfo.deptId),
            depotId: this.formData.depotId,
            createUser: Number(this.userInfo.userId),
            createUserName: this.userInfo.nickname,
            mechanismId: this.formData.companyId,
            detail: detail,
          }).then(res => {
            if (res.code == "200") {
              this.$emit("handle-submit", res.data)
            }
            else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    GetDepotInfo() {
      getDepotInfo({ deptId: this.userInfo.deptId }).then((res) => {
        this.DepotInfo = res.data;
      })
    },
    onChangeDepot(val) {
      this.VertifyInstrument = []
      GetVertifyInstrument(val).then((res) => {
        if (res.code == 200 && res.data) {
          this.VertifyInstrument = res.data.map((item, index) => {
            return {
              key: item.id,
              label: item.instrumentName,
            }
          });
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  height: 400px;
}
.footer {
  margin-top: 24px;
  clear: both;
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: right;
}
.success-v {
  padding-top: 100px;
  text-align: center;
  .success-icon {
    i {
      font-size: 56px;
    }
  }
  .success-title {
    margin: 12px;
    font-size: 24px;
  }
  .success-content {
    color: #909399;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/maintenance/components/onlineTestModal.vue